<script setup lang="ts">
import type { IconName } from '~/components/ui/Icon.vue';

defineProps<{
  sideBarStatus: boolean;
  to: string;
  icon: IconName;
  condition: boolean;
  label: string;
}>();
</script>
<template>
  <nuxt-link
    v-if="sideBarStatus"
    class="group flex items-center rounded-lg truncate w-full px-2 py-2 gap-4"
    :class="[condition ? 'text-emerald-600 bg-gray-100' : 'hover:bg-gray-100 text-gray-600 cursor-pointer']"
    :to="to"
  >
    <ui-icon class="h-[18px]" :class="[condition ? 'stroke-emerald-600' : 'stroke-gray-600']" :stroke-width="2" :name="icon" />
    <span class="text-sm">
      {{ label }}
    </span>
  </nuxt-link>
  <nrjx-tooltip v-else :message="label" side="right" :side-offset="20">
    <nuxt-link
      class="h-8 w-8 group flex items-center rounded-lg truncate justify-center"
      :class="[condition ? 'text-emerald-600 bg-gray-100' : 'hover:bg-gray-100 text-gray-600 cursor-pointer']"
      :to="to"
    >
      <ui-icon class="h-[18px]" :class="[condition ? 'stroke-emerald-600' : 'stroke-gray-600']" :stroke-width="2" :name="icon" />
    </nuxt-link>
  </nrjx-tooltip>
</template>
